import { Tag, Switch, Button } from "antd";
import * as SHARED from "../../utils/shared";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

export function createColumns(page) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Apellidos",
      dataIndex: "apellidos",
      key: "apellidos",
      sorter: (a, b) => a.apellidos.localeCompare(b.apellidos),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombres",
      dataIndex: "nombres",
      key: "nombres",
      sorter: (a, b) => a.nombres.localeCompare(b.nombres),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Estado",
      dataIndex: "state",
      key: "state",
      render: (isInscribed) => {
        let color = "";
        let text = "";
        switch (isInscribed) {
          case "validado":
            color = "yellow";
            text = `${SHARED.VALIDADO}`;
            break;
          case "sorteado":
            color = "green";
            text = `${SHARED.ESTADO_SORTEADO}`;
            break;
          default:
            color = "default";
            text = "Resultado no esperado";
            break;
        }
        return (
          <Tag color={color} key={isInscribed}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "Ganadores del sorteo",
          value: "sorteados"
        },
        {
          text: "Participantes validados",
          value: "validados"
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.state.indexOf(value) === 0,
      sorter: (a, b) => {
        return a.state.length - b.state.length;
      },
      sortDirections: ["descend", "ascend"]
    }
  ];
}

export function columnsParticipantes(page) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 100 + index + 1
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    }
  ];
}

export function columnsSorteo(page, onChangeState, showDetails, showEditModal, handleDelete) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "FECHA",
      dataIndex: "fecha",
      key: "fecha",
      render: (fecha) => {
        return <p>{moment(fecha).format("DD/MM/YYYY")}</p>;
      },
      sorter: (a, b) => new Date(a.fecha) - new Date(b.fecha),
      defaultSortOrder: "descend"
    },
    {
      title: "HORA",
      dataIndex: "fecha",
      key: "fecha",
      render: (fecha) => {
        return <p>{moment(fecha).format("hh:mm a")}</p>;
      },
      sorter: (a, b) => new Date(a.fecha) - new Date(b.fecha)
    },
    {
      title: "NOMBRE",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "CÓDIGO",
      dataIndex: "codigo",
      key: "codigo",
      sorter: (a, b) => a.codigo.localeCompare(b.codigo),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "SORTEADOS",
      dataIndex: "nroganadores",
      key: "nroganadores",
      sorter: (a, b) => a.nroganadores - b.nroganadores,
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Publicado",
      key: "index",
      render: (record) => (
        <span>
          <Switch checked={record.isActivo} onChange={() => onChangeState(record)} />
        </span>
      )
    },
    {
      title: "Acciones",
      key: "action",
      render: (record) => (
        <span>
          <Button icon={<EyeOutlined />} onClick={() => showDetails(record)} />
          <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} />
          <Button icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
        </span>
      )
    }
  ];
}
